export const ADDTHIS = {
  config: { pubid: 'ra-568275e9f9cf2825' },
  share: { passthrough: { twitter: { via: 'bonkers_ie' } } }
};
